import React, { useState, useEffect } from 'react'
import { Classes, Dialog, Radio, RadioGroup } from '@blueprintjs/core'
import { Flex, Toaster, Icon } from '@ui'
import api from '@api'
import { IUsageType } from '@api'
import { ApolloError } from 'apollo-client'
import useFloor from '@providers/mapProvider/floorProvider/provider'
import css from './spaceType.module.scss'
import { EvoGhostButton, EvoButton } from '@ui/buttons/EvoButton'
import { Button } from '@runeffective/evo-design-system'

export interface UsageTypesDialogProps {
  setisUsageTypeOpen: (para: boolean) => void
  isUsageTypeOpen: boolean
  selectedSpaces: string[]
  setisNeighborhoodOpen: (para: boolean) => void
}

export default function UsageTypesDialog({
  setisUsageTypeOpen,
  isUsageTypeOpen,
  selectedSpaces,
  setisNeighborhoodOpen,
}: UsageTypesDialogProps) {
  const [usageTypesList, setusageTypesList] = useState<IUsageType[]>([])
  const [btnDisabled, setBtnDisabled] = useState(true)
  const [selectedValue, setSelectedValue] = useState('')
  const floor = useFloor()

  useEffect(() => {
    api.company.usageTypes().then((usageTypes) => setusageTypesList(usageTypes))
  }, [])

  function onClearAll() {
    setBtnDisabled(true)
    setSelectedValue('')
  }

  function onClickSubmit() {
    api.space
      .batchUpdateUsageTypes(selectedSpaces, selectedValue)
      .then(() => {
        Toaster.success({ message: 'Usage Type updated successfully' })
        floor.reloadMap?.()
        setisUsageTypeOpen(false)
      })
      .catch((error: ApolloError) => {
        Toaster.fail({ error })
      })
    onClearAll()
    if (selectedValue == 'neighborhood') {
      setisNeighborhoodOpen(true)
    }
  }

  return (
    <>
      <Dialog
        style={{ paddingBottom: '0px' }}
        isOpen={isUsageTypeOpen}
        className={css.dialogWidth}
        transitionDuration={200}
        isCloseButtonShown={true}
        canOutsideClickClose={false}
        onClose={() => {
          setisUsageTypeOpen(false)
          onClearAll()
        }}
      >
        <div className={css.empList}>
          <Button
            style={{ position: 'absolute', top: '5px', right: '10px' }}
            aria-label="single icon button"
            onClick={() => {
              setisUsageTypeOpen(false)
              onClearAll()
            }}
            size="default"
            layout="borderless"
          >
            <Icon name="close" />
          </Button>
          <div>
            <div className={css.dialogHeader}> Usage Types </div>
          </div>
          <div>
            <div className={css.labelText}>
              Update the selected spaces to the appropriate usage type
            </div>
            <div className={css.paddingTop}>
              {usageTypesList.map((item) => (
                <div className={css.checkboxPaddingTop} key={item.id}>
                  <RadioGroup
                    inline
                    onChange={(event) => {
                      const val = event.currentTarget.value
                      setSelectedValue(val)
                      setBtnDisabled(false)
                    }}
                    selectedValue={selectedValue}
                  >
                    <Radio
                      label={`${item.displayName}`}
                      value={`${item.name}`}
                      style={{ marginBottom: '0px' }}
                    />
                  </RadioGroup>
                </div>
              ))}
            </div>
          </div>

          <div className={Classes.DIALOG_FOOTER} style={{ marginTop: 10 }}>
            <div className={Classes.DIALOG_FOOTER_ACTIONS}>
              <Flex style={{ gap: '8px' }} direction="row" justify="space-between">
                <Button
                  layout="borderless"
                  onClick={() => {
                    setisUsageTypeOpen(false)
                    onClearAll()
                  }}
                  size="default"
                >
                  Cancel
                </Button>
                <Button
                  disabled={btnDisabled}
                  layout="primary"
                  onClick={() => onClickSubmit()}
                  size="default"
                >
                  Update
                </Button>
              </Flex>
            </div>
          </div>
        </div>
      </Dialog>
    </>
  )
}
